import { render, staticRenderFns } from "./heroAddGalleryAdmin.vue?vue&type=template&id=4c94f20a&"
import script from "./heroAddGalleryAdmin.vue?vue&type=script&lang=js&"
export * from "./heroAddGalleryAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports